import React from 'react';
import PropType from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class HeatmapTable extends React.Component {
  handleGeneClick = gene => () => {
    const { category } = this.props;

    if (category === 'singlecell') {
      this.redirectToViolinPlot(gene);
    } else {
      this.redirectToBarPlot(gene);
    }
  }

  redirectToViolinPlot(gene) {
    const { params } = this.props;
    const payload = {
      type: 'violinplot',
      category: 'singlecell',
      gene,
      ord: params.ord,
    };
    // submit values to the backend storage and retrieve the uuid
    axios.post(`${apiProto}://${apiHost}/search`, payload).then((response) => {
      // redirect to the results page which will load in the image and parameters.
      const redirect = `/single-cell/violin/${response.data}`;
      this.props.history.push(redirect);
    });
  }

  redirectToBarPlot(gene) {
    const { params } = this.props;
    const payload = {
      type: 'barplot',
      category: 'nuclei',
      genes: [gene],
      ord: params.ord,
    };
    // submit values to the backend storage and retrieve the uuid
    axios.post(`${apiProto}://${apiHost}/search`, payload).then((response) => {
      // redirect to the results page which will load in the image and parameters.
      const redirect = `/nuclei/barplot/${response.data}`;
      this.props.history.push(redirect);
    });
  }

  render() {
    const { results } = this.props;
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Gene</th>
          </tr>
        </thead>
        <tbody>
          {results.map((n) => {
            return (
              <tr key={n}>
                <td><a role="link" onClick={this.handleGeneClick(n)}>{n}</a></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

HeatmapTable.propTypes = {
  results: PropType.array.isRequired,
  params: PropType.object.isRequired,
  history: PropType.object.isRequired,
  category: PropType.string,
};

HeatmapTable.defaultProps = {
  category: 'nuclei',
};

export default withRouter(HeatmapTable);



// WEBPACK FOOTER //
// ./src/components/HeatmapTable.jsx